import React from 'react';

interface LogoProps {
  size?: number;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 32, className = '' }) => {
  return (
    <div 
      className={className}
      style={{ 
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        color: 'white',
        fontWeight: 'bold',
        fontSize: size * 0.5
      }}
      title="Riselio"
    >
      <img src='/logo.png' alt="Riselio" style={{ width: '80%', height: '80%' }} />
    </div>
  );
};

export default Logo;
